import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-navbar',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseNavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
